<template>

    <div class="welcome-to-origo-component h-100">

        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-12">
                    <div class="card">
                        <div class="row">
                            <div class="col-12 col-lg-6 left text-center">

                                <h1 class="text-uppercase">Reset your <span>password</span></h1>

                                <h2>Thank You!</h2>

                                <p>If a user has been found using the details you provided, password reset instructions will be sent to your email address.</p>

                            </div>
                            <div class="col-12 col-lg-6 right text-center">
                                <div class="d-flex flex-column h-100 justify-content-center">
                                    <div>
                                        <i class="logo-icon"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>
